// extracted by mini-css-extract-plugin
export default {"main":"SelectAddons_main__012ht","list":"SelectAddons_list__BhXeR"};